
      import SingleList from './single-list.vue'
      import type { App, Plugin } from 'vue'

      export const SingleListPlugin: Plugin = {
        install(app: App) {
          app.component('SingleList', SingleList)
        },
      }
      export { SingleList }
      